export enum EVerifiedStatus {
  Confirmed = 'confirmed',
  Checked = 'checked',
  Validated = 'validated',
  Banned = 'banned',
  Archived = 'archived',
  RestrictedLatePayment45 = 'restricted_late_payment_45_days',
  RestrictedLatePayment60 = 'restricted_late_payment_60_days',
  RestrictedWaitForInfo = 'restricted_waiting_for_info',
  RestrictedOther = 'restricted_other'
}

export const isShowingBanner = [
  EVerifiedStatus.RestrictedLatePayment45,
  EVerifiedStatus.RestrictedLatePayment60,
  EVerifiedStatus.RestrictedWaitForInfo,
  EVerifiedStatus.Banned,
  EVerifiedStatus.RestrictedOther
];

export const allowedToSeeAddCartButton = [
  EVerifiedStatus.Confirmed,
  EVerifiedStatus.Validated,
  EVerifiedStatus.RestrictedLatePayment45,
  EVerifiedStatus.RestrictedWaitForInfo
];

export const allowedToSeeJobList = [
  EVerifiedStatus.Confirmed,
  EVerifiedStatus.Checked,
  EVerifiedStatus.Validated,
  EVerifiedStatus.RestrictedLatePayment45,
  EVerifiedStatus.RestrictedLatePayment60,
  EVerifiedStatus.RestrictedWaitForInfo,
  EVerifiedStatus.RestrictedOther
];

export const allowedToBuyJobs = [
  EVerifiedStatus.Checked,
  EVerifiedStatus.Validated
];

export const allowedToLateInvoiceFeature = [EVerifiedStatus.Validated];

export const allowedToAccessInvoice = [
  EVerifiedStatus.Confirmed,
  EVerifiedStatus.Checked,
  EVerifiedStatus.Validated,
  EVerifiedStatus.RestrictedLatePayment45,
  EVerifiedStatus.RestrictedLatePayment60,
  EVerifiedStatus.RestrictedWaitForInfo,
  EVerifiedStatus.Banned,
  EVerifiedStatus.RestrictedOther
];

export const allowedToAccessHistory = [
  EVerifiedStatus.Confirmed,
  EVerifiedStatus.Checked,
  EVerifiedStatus.Validated,
  EVerifiedStatus.RestrictedLatePayment45,
  EVerifiedStatus.RestrictedWaitForInfo,
  EVerifiedStatus.RestrictedOther
];

export const allowedToAccessMyCalendar = [
  EVerifiedStatus.Validated,
  EVerifiedStatus.Confirmed,
  EVerifiedStatus.Checked,
  EVerifiedStatus.RestrictedLatePayment45
];

export const allowedToAccessMyPrebook = [
  EVerifiedStatus.Validated,
  EVerifiedStatus.Confirmed,
  EVerifiedStatus.Checked
];

export const allowedToAccessMyProfile = [
  EVerifiedStatus.Confirmed,
  EVerifiedStatus.Checked,
  EVerifiedStatus.Validated,
  EVerifiedStatus.RestrictedLatePayment45,
  EVerifiedStatus.RestrictedLatePayment60,
  EVerifiedStatus.RestrictedWaitForInfo,
  EVerifiedStatus.RestrictedOther
];
